import { Alert } from "./Alert";

export const ErrorAlert = ( { errorMessage } ) => (
	<Alert message={errorMessage} type="error"/>
);